import MaterialLoadingButton, {
    LoadingButtonProps,
} from '@mui/lab/LoadingButton';

export function LoadingButton(props: LoadingButtonProps) {
    return (
        <MaterialLoadingButton
            data-testid={'LoadingButton-container'}
            {...props}
        />
    );
}

export default LoadingButton;
